module.exports = __webpack_public_path__ + "img/s01.c953abd3.png";